var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "export-csv",
    class: {
      'export-csv--locked': _vm.isDisabled
    }
  }, [_vm.isDisabled ? _c('span', {
    staticClass: "export-csv__tooltip",
    attrs: {
      "role": "tooltip"
    }
  }, [_vm._v(" " + _vm._s(_vm.activeTooltipText) + " ")]) : _vm._e(), _c('Button', {
    class: {
      'opacity-50 cursor-not-allowed': _vm.isDisabled
    },
    attrs: {
      "variant": "outlined",
      "color": "alternative",
      "size": "sm",
      "disabled": _vm.isDisabled
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('click');
      }
    },
    scopedSlots: _vm._u([{
      key: "iconBefore",
      fn: function () {
        return [_c('i', {
          staticClass: "fa-solid fa-file-csv"
        })];
      },
      proxy: true
    }])
  }, [_vm._v(" " + _vm._s(_vm.isExporting ? 'Exporting...' : 'Export .CSV') + " "), _vm.countdown > 0 ? _c('span', [_vm._v("(" + _vm._s(_vm.countdownText) + ")")]) : _vm._e()])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }